module.exports = require('../dist/drivers/auto-loans');
